import React from 'react';
import classNames from 'classnames';
import { MOBILE_IMAGE, DESKTOP_IMAGE } from '../config';

import './style.scss';

const CompanyLogo = ({ company }) => {
    const className = classNames({
        'display-from-sm': company.displayFromSm
    });

    return (
        <li className={className}>
            <picture>
                <source media={MOBILE_IMAGE} srcSet={company.mobile}/>
                <source media={DESKTOP_IMAGE} srcSet={company.desktop}/>
                <img src={company.src} alt={company.alt}/>
            </picture>
        </li>
    );
};

export default CompanyLogo;
